// extracted by mini-css-extract-plugin
export default {"iframeContainer":"iframe-module__iframeContainer__5a2Zp"};